import React, { Component } from "react";
import { Button } from 'react-bootstrap'
import { connect } from "react-redux";

import StartLearning from '../asset_components/StartLearningBttn'
import LoadingBttn from "./LoadingBttn";

class LoadingLearning extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      isLoading: false
    };
  }

  handleClick() {
    this.setState({ isLoading: true });
    this.props.trainingStartStop(true)
    this.props.modelCall()
  }
  
  componentWillReceiveProps(nextProps) {    
    if(!nextProps.startStop)
      this.setState({isLoading: false})
  }

  render() {
    const { isLoading } = this.state;

    return (
      <Button
      style={{ padding: "0px", border: "0px", outline: "none" }}
        bsStyle="primary"
        disabled={isLoading}
        onClick={!isLoading ? this.handleClick : null}
        disabled={this.props.bttnStatus}
      >
        {isLoading ? <LoadingBttn epochs={this.props.epochs}/> : <StartLearning/> }
      </Button>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    startStop: state.startStop
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    //TRUE WHEN TRAINING START AND FALSE WHEN STOPPED
    trainingStartStop: (status) => {
      dispatch({
        type: 'TRAINING_START_STOP',
        startStopSignal: status
      })
    },
  }
}

export default connect (mapStateToProps, mapDispatchToProps)(LoadingLearning);
